import { render, staticRenderFns } from "./subjectColumn.vue?vue&type=template&id=84d15f32&scoped=true&"
import script from "./subjectColumn.vue?vue&type=script&lang=js&"
export * from "./subjectColumn.vue?vue&type=script&lang=js&"
import style0 from "./subjectColumn.vue?vue&type=style&index=0&id=84d15f32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d15f32",
  null
  
)

export default component.exports